import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorService, ErrorMessage } from '../../../core/services/error.service';

@Component({
  selector: 'app-error-notification',
  standalone: false,
  templateUrl: './error-notification.component.html',
  styleUrl: './error-notification.component.css'
})
export class ErrorNotificationComponent implements OnInit, OnDestroy {
  error: ErrorMessage | null = null;
  private errorSubscription?: Subscription;
  private autoHideTimeout?: ReturnType<typeof setTimeout>;

  constructor(
    private errorService: ErrorService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.errorSubscription = this.errorService.error$.subscribe((error) => {
      this.clearTimeout();
      this.error = error;

      if (error) {
        const ms = error.autoDismissMs ?? this.getDefaultAutoDismissMs(error);
        if (ms != null && ms > 0) {
          this.autoHideTimeout = setTimeout(() => {
            this.dismiss();
          }, ms);
        }
      }
      this.cdr.markForCheck();
    });
  }

  private getDefaultAutoDismissMs(error: ErrorMessage): number | undefined {
    if (error.type !== 'error') return 5000;
    if (error.statusCode != null && error.statusCode < 500) return 5000;
    return undefined;
  }

  ngOnDestroy(): void {
    this.errorSubscription?.unsubscribe();
    this.clearTimeout();
  }

  dismiss(): void {
    this.clearTimeout();
    this.errorService.clearError();
    this.cdr.markForCheck();
  }

  private clearTimeout(): void {
    if (this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout);
      this.autoHideTimeout = undefined;
    }
  }

  getIconClass(): string {
    if (!this.error) return '';
    
    switch (this.error.type) {
      case 'error':
        return 'fas fa-exclamation-circle text-red-600';
      case 'warning':
        return 'fas fa-exclamation-triangle text-yellow-600';
      case 'info':
        return 'fas fa-info-circle text-blue-600';
      case 'success':
        return 'fas fa-check-circle text-green-600';
      default:
        return 'fas fa-info-circle text-gray-600';
    }
  }

  getBackgroundColor(): string {
    if (!this.error) return '';
    
    switch (this.error.type) {
      case 'error':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'warning':
        return 'bg-yellow-50 border-yellow-200 text-yellow-800';
      case 'info':
        return 'bg-blue-50 border-blue-200 text-blue-800';
      case 'success':
        return 'bg-green-100 border-green-300 text-green-800';
      default:
        return 'bg-gray-50 border-gray-200 text-gray-800';
    }
  }
}
